import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatepipPipe implements PipeTransform {
  transform(value1: string, value2: string, truncateLength: number): string {
    if (!value1 || !value2) {
      return '';
    }
    let result = value1 + ' ' + value2;
    if (truncateLength && result.length > truncateLength) {
      result = result.substring(0, truncateLength) + '...';
    }
    return result;
  }
}
